(function ($) {
	'use strict';

	if (
		typeof elementor === 'undefined' ||
		!elementor.modules ||
		!elementor.modules.controls ||
		!elementor.modules.controls.BaseData
	) {
		return;
	}

	var styleInjected = false;

	function escapeHtml(value) {
		return String(value || '')
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	}

	function defaultCell() {
		return { type: 'text', text: 'Value' };
	}

	function normalizeCell(cell) {
		var normalized = cell && typeof cell === 'object' ? cell : {};
		var validTypes = {
			text: true,
			check: true,
			cross: true,
			check_label: true,
			cross_label: true,
		};
		return {
			type: validTypes[normalized.type] ? normalized.type : 'text',
			text: typeof normalized.text === 'string' ? normalized.text : '',
		};
	}

	function normalizeRow(row) {
		var normalized = row && typeof row === 'object' ? row : {};
		var cells = Array.isArray(normalized.cells) ? normalized.cells.map(normalizeCell) : [];
		if (!cells.length) {
			cells = [defaultCell()];
		}
		return {
			name: typeof normalized.name === 'string' ? normalized.name : 'Feature Name',
			cells: cells,
		};
	}

	function normalizeCategory(category) {
		var normalized = category && typeof category === 'object' ? category : {};
		var rows = Array.isArray(normalized.rows) ? normalized.rows.map(normalizeRow) : [];
		if (!rows.length) {
			rows = [normalizeRow({})];
		}
		return {
			title: typeof normalized.title === 'string' ? normalized.title : 'Category',
			rows: rows,
		};
	}

	function parseMatrix(value) {
		if (Array.isArray(value)) {
			return value.map(normalizeCategory);
		}

		if (typeof value !== 'string' || !value.trim()) {
			return [];
		}

		try {
			var parsed = JSON.parse(value);
			return Array.isArray(parsed) ? parsed.map(normalizeCategory) : [];
		} catch (e) {
			return [];
		}
	}

	var FeatureMatrixControl = elementor.modules.controls.BaseData.extend({
		events: {
			'click .thha-fcm-add-category': 'onAddCategory',
			'click .thha-fcm-remove-category': 'onRemoveCategory',
			'input .thha-fcm-category-title': 'onCategoryTitleChange',
			'click .thha-fcm-add-row': 'onAddRow',
			'click .thha-fcm-remove-row': 'onRemoveRow',
			'input .thha-fcm-row-name': 'onRowNameChange',
			'click .thha-fcm-add-cell': 'onAddCell',
			'click .thha-fcm-remove-cell': 'onRemoveCell',
			'change .thha-fcm-cell-type': 'onCellTypeChange',
			'input .thha-fcm-cell-text': 'onCellTextChange',
		},

		onReady: function () {
			this.injectStyle();
			this.initializeMatrix();
		},

		injectStyle: function () {
			if (styleInjected || document.getElementById('thha-fcm-control-style')) {
				styleInjected = true;
				return;
			}

			var css = '' +
				'.thha-fcm-root{margin-top:8px;border:1px solid #d5d8dc;border-radius:8px;background:#fff;padding:10px}' +
				'.thha-fcm-toolbar{display:flex;justify-content:flex-end;margin-bottom:8px}' +
				'.thha-fcm-btn{border:1px solid #c9ced4;background:#fff;color:#1f2937;border-radius:4px;padding:5px 8px;font-size:11px;line-height:1.2;cursor:pointer}' +
				'.thha-fcm-btn:hover{background:#f5f7fa}' +
				'.thha-fcm-btn-danger{border-color:#f0b8b8;color:#8a2424}' +
				'.thha-fcm-category{border:1px solid #e5e7eb;border-radius:6px;padding:8px;margin-bottom:10px;background:#fbfbfc}' +
				'.thha-fcm-category-head{display:flex;gap:8px;align-items:center;margin-bottom:8px}' +
				'.thha-fcm-input{width:100%;border:1px solid #d1d5db;border-radius:4px;padding:6px 8px;font-size:12px}' +
				'.thha-fcm-rows{display:grid;gap:8px}' +
				'.thha-fcm-row{border:1px solid #e5e7eb;border-radius:6px;background:#fff;padding:8px}' +
				'.thha-fcm-row-head{display:flex;gap:8px;align-items:center;margin-bottom:8px}' +
				'.thha-fcm-cells{display:grid;gap:6px;margin-bottom:8px}' +
				'.thha-fcm-cell{display:grid;grid-template-columns:minmax(120px,170px) minmax(120px,1fr) auto;gap:6px;align-items:center}' +
				'.thha-fcm-select{border:1px solid #d1d5db;border-radius:4px;padding:5px 6px;font-size:12px;max-width:170px}' +
				'.thha-fcm-cell-text[disabled]{background:#f1f3f5;color:#8b8f96}' +
				'.thha-fcm-row-actions,.thha-fcm-category-actions{display:flex;gap:6px;justify-content:flex-end}' +
				'.thha-fcm-empty{padding:8px;color:#6b7280;font-size:12px;text-align:center;border:1px dashed #d1d5db;border-radius:6px;background:#fff}';

			var style = document.createElement('style');
			style.id = 'thha-fcm-control-style';
			style.appendChild(document.createTextNode(css));
			document.head.appendChild(style);
			styleInjected = true;
		},

		getCellTypeOptions: function () {
			var options = this.model.get('cell_options');
			if (options && typeof options === 'object') {
				return options;
			}

			return {
				text: 'Text',
				check: 'Check Icon',
				cross: 'Cross Icon',
				check_label: 'Check Icon + Label',
				cross_label: 'Cross Icon + Label',
			};
		},

		getDefaultMatrix: function () {
			var defaults = parseMatrix(this.model.get('default'));
			if (defaults.length) {
				return defaults;
			}
			return [normalizeCategory({})];
		},

		getLegacyCategories: function () {
			if (!this.container || !this.container.settings) {
				return [];
			}

			var legacy = this.container.settings.get('comparison_categories');
			return Array.isArray(legacy) ? legacy.map(normalizeCategory) : [];
		},

		initializeMatrix: function () {
			var matrix = parseMatrix(this.getControlValue());

			if (!matrix.length) {
				matrix = this.getLegacyCategories();
			}

			if (!matrix.length) {
				matrix = this.getDefaultMatrix();
			}

			this.matrix = matrix;
			this.refresh();
		},

		refresh: function () {
			this.syncValue();
			this.renderEditor();
		},

		syncValue: function () {
			var value = JSON.stringify(this.matrix);
			this.setValue(value);
			this.$('input[data-setting]').val(value).trigger('input');
		},

		renderEditor: function () {
			var html = '<div class="thha-fcm-toolbar"><button type="button" class="thha-fcm-btn thha-fcm-add-category">+ Add Category</button></div>';
			html += '<div class="thha-fcm-categories">';

			if (!this.matrix.length) {
				html += '<div class="thha-fcm-empty">No categories yet.</div>';
			}

			for (var c = 0; c < this.matrix.length; c++) {
				html += this.renderCategory(this.matrix[c], c);
			}

			html += '</div>';
			this.$('.thha-fcm-root').html(html);
		},

		renderCategory: function (category, categoryIndex) {
			var html = '';
			html += '<div class="thha-fcm-category" data-category-index="' + categoryIndex + '">';
			html += '<div class="thha-fcm-category-head">';
			html += '<input class="thha-fcm-input thha-fcm-category-title" type="text" value="' + escapeHtml(category.title) + '" placeholder="Category Title" />';
			html += '<button type="button" class="thha-fcm-btn thha-fcm-btn-danger thha-fcm-remove-category">Remove</button>';
			html += '</div>';
			html += '<div class="thha-fcm-rows">';

			for (var r = 0; r < category.rows.length; r++) {
				html += this.renderRow(category.rows[r], categoryIndex, r);
			}

			html += '</div>';
			html += '<div class="thha-fcm-category-actions"><button type="button" class="thha-fcm-btn thha-fcm-add-row">+ Add Row</button></div>';
			html += '</div>';
			return html;
		},

		renderRow: function (row, categoryIndex, rowIndex) {
			var html = '';
			html += '<div class="thha-fcm-row" data-category-index="' + categoryIndex + '" data-row-index="' + rowIndex + '">';
			html += '<div class="thha-fcm-row-head">';
			html += '<input class="thha-fcm-input thha-fcm-row-name" type="text" value="' + escapeHtml(row.name) + '" placeholder="Feature Name" />';
			html += '<button type="button" class="thha-fcm-btn thha-fcm-btn-danger thha-fcm-remove-row">Remove</button>';
			html += '</div>';
			html += '<div class="thha-fcm-cells">';

			for (var i = 0; i < row.cells.length; i++) {
				html += this.renderCell(row.cells[i], categoryIndex, rowIndex, i);
			}

			html += '</div>';
			html += '<div class="thha-fcm-row-actions"><button type="button" class="thha-fcm-btn thha-fcm-add-cell">+ Add Cell</button></div>';
			html += '</div>';
			return html;
		},

		renderCell: function (cell, categoryIndex, rowIndex, cellIndex) {
			var options = this.getCellTypeOptions();
			var html = '';
			html += '<div class="thha-fcm-cell" data-category-index="' + categoryIndex + '" data-row-index="' + rowIndex + '" data-cell-index="' + cellIndex + '">';
			html += '<select class="thha-fcm-select thha-fcm-cell-type">';

			Object.keys(options).forEach(function (key) {
				var selected = key === cell.type ? ' selected' : '';
				html += '<option value="' + escapeHtml(key) + '"' + selected + '>' + escapeHtml(options[key]) + '</option>';
			});

			var needsText = cell.type === 'text' || cell.type === 'check_label' || cell.type === 'cross_label';
			var disabled = needsText ? '' : ' disabled';
			html += '</select>';
			html += '<input class="thha-fcm-input thha-fcm-cell-text" type="text" value="' + escapeHtml(cell.text) + '" placeholder="Text / Label"' + disabled + ' />';
			html += '<button type="button" class="thha-fcm-btn thha-fcm-btn-danger thha-fcm-remove-cell">Remove</button>';
			html += '</div>';
			return html;
		},

		getIndexes: function (eventTarget) {
			var $item = $(eventTarget).closest('[data-category-index]');
			return {
				categoryIndex: parseInt($item.attr('data-category-index'), 10),
				rowIndex: parseInt($item.attr('data-row-index'), 10),
				cellIndex: parseInt($item.attr('data-cell-index'), 10),
			};
		},

		onAddCategory: function () {
			this.matrix.push(normalizeCategory({}));
			this.refresh();
		},

		onRemoveCategory: function (event) {
			var index = this.getIndexes(event.currentTarget).categoryIndex;
			if (Number.isInteger(index) && this.matrix[index]) {
				this.matrix.splice(index, 1);
				this.refresh();
			}
		},

		onCategoryTitleChange: function (event) {
			var index = this.getIndexes(event.currentTarget).categoryIndex;
			if (Number.isInteger(index) && this.matrix[index]) {
				this.matrix[index].title = $(event.currentTarget).val();
				this.syncValue();
			}
		},

		onAddRow: function (event) {
			var index = this.getIndexes(event.currentTarget).categoryIndex;
			if (Number.isInteger(index) && this.matrix[index]) {
				this.matrix[index].rows.push(normalizeRow({}));
				this.refresh();
			}
		},

		onRemoveRow: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			if (
				Number.isInteger(indexes.categoryIndex) &&
				Number.isInteger(indexes.rowIndex) &&
				this.matrix[indexes.categoryIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex]
			) {
				this.matrix[indexes.categoryIndex].rows.splice(indexes.rowIndex, 1);
				this.refresh();
			}
		},

		onRowNameChange: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			if (
				Number.isInteger(indexes.categoryIndex) &&
				Number.isInteger(indexes.rowIndex) &&
				this.matrix[indexes.categoryIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex]
			) {
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].name = $(event.currentTarget).val();
				this.syncValue();
			}
		},

		onAddCell: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			if (
				Number.isInteger(indexes.categoryIndex) &&
				Number.isInteger(indexes.rowIndex) &&
				this.matrix[indexes.categoryIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex]
			) {
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells.push(defaultCell());
				this.refresh();
			}
		},

		onRemoveCell: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			if (
				Number.isInteger(indexes.categoryIndex) &&
				Number.isInteger(indexes.rowIndex) &&
				Number.isInteger(indexes.cellIndex) &&
				this.matrix[indexes.categoryIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells[indexes.cellIndex]
			) {
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells.splice(indexes.cellIndex, 1);
				if (!this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells.length) {
					this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells.push(defaultCell());
				}
				this.refresh();
			}
		},

		onCellTypeChange: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			if (
				Number.isInteger(indexes.categoryIndex) &&
				Number.isInteger(indexes.rowIndex) &&
				Number.isInteger(indexes.cellIndex) &&
				this.matrix[indexes.categoryIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells[indexes.cellIndex]
			) {
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells[indexes.cellIndex].type = $(event.currentTarget).val();
				this.refresh();
			}
		},

		onCellTextChange: function (event) {
			var indexes = this.getIndexes(event.currentTarget);
			if (
				Number.isInteger(indexes.categoryIndex) &&
				Number.isInteger(indexes.rowIndex) &&
				Number.isInteger(indexes.cellIndex) &&
				this.matrix[indexes.categoryIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex] &&
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells[indexes.cellIndex]
			) {
				this.matrix[indexes.categoryIndex].rows[indexes.rowIndex].cells[indexes.cellIndex].text = $(event.currentTarget).val();
				this.syncValue();
			}
		},
	});

	elementor.addControlView('thha-feature-matrix', FeatureMatrixControl);
})(jQuery);
